import { render } from "./NoticeColumn.vue?vue&type=template&id=4cd86362"
import script from "./NoticeColumn.vue?vue&type=script&lang=js"
export * from "./NoticeColumn.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__